import React from 'react';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

interface StatusBadgeProps {
  isActive: boolean;
  activeText?: string;
  inactiveText?: string;
  className?: string;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({
  isActive,
  activeText = "Active",
  inactiveText = "Inactive",
  className
}) => {
  return (
    <Badge 
      variant={isActive ? "default" : "secondary"}
      className={cn(
        isActive 
          ? "bg-green-100 text-green-800 border-green-200 hover:bg-green-100" 
          : "",
        className
      )}
    >
      {isActive ? activeText : inactiveText}
    </Badge>
  );
};